import { renewToken } from "./auth";
import { LaunchError } from "../utils/errors";
import { analyzeVideoSubtitlesRequest } from "../services/videoSubtitles";
import { applyVideoEditorEdl } from "./videoEditor";
import { startSaveCreativesVideoEdited } from "./videoEditorProject";
import { selectVideoEditorEdl } from "../features/videoEditor/videoEditorSelectors";
import {
  applySubtitlesSidecarToEdl,
  edlHasSubtitleClips,
} from "../features/videoEditor/subtitleEdl";
import { DEFAULT_SUBTITLE_OPTIONS } from "../components/Modal/ModalCreateWithIA/subtitlePresets";

export const startAnalyzeVideoSubtitles =
  ({ url, subtitleOptions, language }) =>
  async (dispatch) => {
    try {
      const token = await dispatch(renewToken());
      const response = await analyzeVideoSubtitlesRequest({
        token,
        url,
        subtitleOptions,
        language,
      });
      return response;
    } catch (error) {
      dispatch(
        LaunchError(error, false, [], {
          functionName: "startAnalyzeVideoSubtitles",
        })
      );
      return { ok: false };
    }
  };

export const startAddVideoEditorSubtitles =
  ({ sourceUrl }) =>
  async (dispatch, getState) => {
    const edl = selectVideoEditorEdl(getState());
    if (!edl) {
      return { ok: false, analyzed: false };
    }

    if (edlHasSubtitleClips(edl)) {
      return { ok: true, analyzed: false };
    }

    const cleanUrl = String(sourceUrl || "").trim();
    if (!cleanUrl) {
      return { ok: false, analyzed: false };
    }

    const analyzed = await dispatch(
      startAnalyzeVideoSubtitles({
        url: cleanUrl,
        subtitleOptions: edl.subtitleOptions || DEFAULT_SUBTITLE_OPTIONS,
      })
    );

    if (!analyzed?.ok || !analyzed.data?.subtitles?.segments?.length) {
      return { ok: false, analyzed: true };
    }

    const nextEdl = applySubtitlesSidecarToEdl({
      edl: selectVideoEditorEdl(getState()) || edl,
      subtitles: analyzed.data.subtitles,
    });

    dispatch(applyVideoEditorEdl({ edl: nextEdl }));

    await dispatch(
      startSaveCreativesVideoEdited({
        sourceUrl: cleanUrl,
        subtitles: analyzed.data.subtitles,
        edl: nextEdl,
      })
    );

    return { ok: true, analyzed: true };
  };
